import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Filter, FilterContracts, HttpService } from "../../services";
import { Agent, Contract, Event, EventFilterDate, EventTypes, Product, StatusContract } from "../../models";
import { ActivatedRoute, Params } from "@angular/router";
import { PagerService } from "../../services/index";
import { TreeUtil } from "../../util/tree";
import { AgentUtility } from "../../util/agent.utility";
import { retry } from "rxjs/operator/retry";
import { StringUtility } from "../../util/string.utility";
import { ContractsService } from "../../services/contracts.service";
import { AgentsService } from "../../services/agents.service";
import { EventFilter, EventsService } from "../../services/events.service";

@Component({
    moduleId: module.id,
    selector: 'portfolio',
    templateUrl: 'portfolio.component.html',
    styles: ['>>> a { cursor: pointer; }'],
    providers: [ContractsService, PagerService, AgentsService, EventsService]
})
export class PortfolioComponent implements OnInit, OnDestroy {
    @ViewChild('filter_tree',{static: false}) container;
    activenodes: any[] = [];
    showfilter: boolean = false;
    showoverlay: boolean = false;
    isMobile: boolean = window.innerWidth <= 1200;

    get ActiveNodes() {
        function sortNodes(firstNode, secondNode) {
            return firstNode.index - secondNode.index
        }

        if (this.activenodes.length > 1)
            this.activenodes.sort(sortNodes);

        return this.activenodes.map(x => x.data.Name).join(', ');
    }

    nodes: any[] = [];
    _agent: Agent = new Agent;
    eventFilterDate = EventFilterDate;
    contracts: Contract[] = [];
    events: Event[];
    types: EventTypes[] = [];
    products: Product[] = [];
    statuses: StatusContract[] = [];
    otherAgent: boolean;
    agentId: number;
    date: Date = new Date;
    showStartDate: boolean = false;
    datepickerOpts: any = {
        autoclose: true,
        todayHighlight: true,
        assumeNearbyYear: true,
        format: 'dd.mm.yyyy',
        placeholder: " ",
        icon: 'client-full__calendar',
        language: 'ru',
        todayBtn: "linked",
    };
    sub: any;
    showAll: boolean = false;
    filterContracts: FilterContracts = new FilterContracts();
    filterEvents: EventFilter = new EventFilter();
    pagerProducts: any = {};
    pagerEvents: any = {};
    pageSize: number = 10;
    totalItemsProducts: number;
    totalItemsEvents: number;
    showLoadScreen: boolean = false;
    treeAgents: any[] = [];
    PSKagents: number[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private agentService: AgentsService,
        private contractsService: ContractsService,
        private pagerService: PagerService,
        private eRef: ElementRef,
        private eventService: EventsService
    ) {
        this.contractsService.onStart = this.agentService.onStart = this.eventService.onStart = () => this.showLoadScreen = true;
        this.contractsService.onEnd = this.agentService.onEnd = this.eventService.onEnd = () => this.showLoadScreen = false;
    }


    eventHandler(event) {
        if (event.key == "Enter")
            this.getContracts();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth <= 1200) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    }

    eventChangeDatePicker(event) {
        if (event == null)
            return false;
        else
            this.getContracts();
    }

    setPageProducts(page: number, needRequest: boolean = false, mobile: boolean = false) {
        if (page < 1)
            return;
        this.pagerProducts = this.pagerService.getPager(this.totalItemsProducts, page, this.pageSize);
        if (mobile)
            this.pagerProducts = this.pagerService.getPagerMobile(this.totalItemsProducts, page, this.pageSize);
        if (page > this.pagerProducts.totalPages) {
            return;
        }

        if (needRequest) {
            this.filterContracts.page = page;
            this.filterContracts.limit = 10;
            this.contractsService.getContracts(this.filterContracts).subscribe((data) => {
                this.contracts = data.data;
                this.totalItemsProducts = data.countAll;
            });
        }
    }

    getExcel(e, type): any {
        e.preventDefault;
        let filter: any = {};
        if (type == 'contracts')
            filter = this.filterContracts;
        else
            filter = this.filterEvents;
        filter.excel = true;
        filter.limit = "all";
        return this.contractsService.getFile(filter, type).subscribe((data) => {
            document.location.href = data.path;
            this.filterContracts.excel = false;
        }
        );
    }

    getUser(): any {
        return AgentUtility.getUser();
    }


    getContracts(): any {
        this.showAll = false;
        this.filterContracts.page = 1;
        this.contractsService.getContracts(this.filterContracts).subscribe((data) => {
            this.contracts = data.data;
            this.totalItemsProducts = data.countAll;
            if (window.innerWidth <= 1200)
                this.setPageProducts(1, false, true);
            else
                this.setPageProducts(1, false);
        }
        );
    }

    getEvents(eventTypeId?): any {
        if (eventTypeId)
            this.filterEvents.EventTypeId = eventTypeId;
        this.filterEvents.page = 1;
        this.eventService.getEvents(this.filterEvents).subscribe((data) => {
            this.events = data.data;
            this.totalItemsEvents = data.countAll;
        });
    }

    active(node) {
        node.data.isChoose = !node.data.isChoose;
        this.expandAndActivate(node);
        var self = this;
        setTimeout(function () {
            self.getContracts();
            self.getStatuses();
            self.getProducts();
        }, 500);

    }

    expandAndActivate(node) {
        if (node.data.isChoose && !node.isExpanded)
            node.expand();
        if (!node.data.isChoose && node.isExpanded)
            node.collapse();
        this.searchForAgents(node);
        node.IsClickedBefore = true;
        if (node.children && node.children.length > 0) {
            for (let i = 0; i < node.data.children.length; i++) {
                if (!(node.children[i].IsClickedBefore)) {
                    node.children[i].data.isChoose = node.data.isChoose;
                    this.expandAndActivate(node.children[i]);
                }

                if (node.children[i].data.isChoose == node.data.isChoose)
                    continue;

                node.children[i].data.isChoose = node.data.isChoose;
                if (node.children[i].data.isChoose == false)
                    this.searchForAgents(node.children[i], false);
                else
                    this.searchForAgents(node.children[i]);
            }
        } else {
            node.children = [];
        }
    }

    searchForAgents(node, choosen = true) {
        let currentUser = AgentUtility.getUser();
        let index = this.activenodes.findIndex(x => x.id == node.id);
        if (index == -1 && !choosen)
            return;
        if (index >= 0) {
            this.activenodes.splice(index, 1);
            let indexContracts = this.filterContracts.agents.indexOf(node.data.Id);
            if (indexContracts != -1)
                this.filterContracts.agents.splice(indexContracts, 1);
            let indexEvents = this.filterEvents.agents.indexOf(node.data.Id);
            if (indexEvents != -1)
                this.filterEvents.agents.splice(indexEvents, 1);
        } else {
            if (currentUser.Id != node.data.Id) {
                this.activenodes.push(node);
                if (this.filterContracts.agents == undefined)
                    this.filterContracts.agents = [];
                this.filterContracts.agents.push(node.data.Id);
                if (this.filterEvents.agents == undefined)
                    this.filterEvents.agents = [];
                this.filterEvents.agents.push(node.data.Id);
            }
        }
    }

    eventClickEvents(Id) {
        this.filterEvents.EventTypeId = Id;
        this.getEvents();

    }

    showAllContracts(): any {
        this.showAll = !this.showAll;
        this.filterContracts.limit = "all";
        this.contractsService.getContracts(this.filterContracts).subscribe((data) => {
            this.pagerProducts.pages = 0;
            this.contracts = data.data;
        }
        );
    }

    getProducts(): any {
        if (this.filterContracts.agents != undefined && this.filterContracts.agents.length > 0) {
            this.contractsService.getProductListAgentsArray(this.filterContracts.agents).subscribe((data) => {
                this.products = data.data;
                //
            }
            );
        } else {
            this.contractsService.getProductList().subscribe((data) => {
                this.products = data.data;
            }
            );
        }
    }

    splited(phone) {
        if (phone != null && phone != "")
            return phone.split(',');
    }


    getStatuses(): any {
        if (this.filterContracts.agents != undefined && this.filterContracts.agents.length > 0) {
            this.contractsService.getStatusesAgentsArray(this.filterContracts.agents).subscribe((data) => {
                this.statuses = data.data;
            }
            );
        } else {
            this.contractsService.getStatusesList().subscribe((data) => {
                this.statuses = data.data;
            }
            );
        }
    }

    getOtherUser(): any {
        if (this._agent != null)
            return this._agent;
        return new Agent;
    }

    toggleSubordinates(currNode, contractLeaderId) {
        let filter = new Filter();
        filter.ContractLeaderId = contractLeaderId != undefined ? contractLeaderId : currNode.Id;
        filter.limit = "all";
        let agents = this.agentService.getAgentsByFilter(filter).subscribe((data) => {
            if (data.data !== undefined && data.data.length > 0) {
                for (let i = 0; i < data.data.length; i++) {
                    data.data[i].hasChildren = true;
                    data.data[i].children = [];
                    data.data[i].isParent = true;
                }
                currNode.children = data.data;
            } else {
                currNode.children = [];
                currNode.hasChildren = false;
                currNode.isParent = false;
            }

            // Фикс рефреша дерева
            this.nodes = [...this.nodes, {}];
            this.nodes.splice(-1, 1);
        });
    }

    ngOnInit() {
        this.filterEvents.typeDate = this.eventFilterDate.Weekly;
        // Грузим дерево агентов для фильтра
        let Id = AgentUtility.getUser().Id;
        this.getProducts();
        this.getStatuses();
        this.agentService.getAgentTreeByFilter(Id, { downOnly: true }).subscribe(res => {
            let data = res.data;
            data[0].isParent = true;
            this.nodes = data;
            // this.getAllChildrens(this.nodes);            
            // this.filterContracts.agents = this.PSKagents.slice(1);
            this.getContracts();
        });
        let filterContracts = JSON.parse(localStorage.getItem('filterContracts'));
        if (filterContracts) {
            if (filterContracts.PersonId)
                this.filterContracts.PersonId = +filterContracts.PersonId;

            localStorage.setItem('filterContracts', null);
        }

        // this.getTypesEvents();
        this.filterContracts.ProductId = -1;
        this.filterContracts.StatusId = 0;
        this.filterEvents.EventTypeId = -1000;
    }

    getAllChildrens(nodes){
        for(var i = 0; i< nodes.length; i++){
            this.PSKagents.push(nodes[i].Id);
            if(nodes[i].children){
                this.getAllChildrens(nodes[i].children);
            }
        }
    }


    ngOnDestroy() {
        // this.sub.unsubscribe();
    }
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.eRef.nativeElement.contains(event.target)) {

        } else {
            if (event.srcElement.pathname == '/portfolio') {
                this.filterContracts = new FilterContracts();
                this.getContracts();
            }

        }
    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }

    getColorStatus(StatusId) {
        var notRedStatuses = [19, 2, 91, 441, 20, 1, 89];
        if (notRedStatuses.indexOf(StatusId) == -1) {
            return 'red';
        } else {
            return 'black';
        }
    }
}